import { StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
    option: theme => ({
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: 12,
        borderBottomWidth: 2,
        borderBottomColor: theme.colors.borderColorThree,
    }),
    outer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 22,
        height: 22,
        backgroundColor: Colors.transparent,
        borderRadius: 11,
        borderWidth: 1,
        margin: 0,
        marginRight: 8,
    },
    outer_isActive_true: {
        borderColor: Colors.ocean,
    },
    outer_isActive_false: {
        borderColor: Colors.platinum,
    },
    inner: {
        margin: 2,
        width: 14,
        height: 14,
        borderRadius: 7,
    },
    inner_isActive_true: {
        backgroundColor: Colors.ocean,
    },
    inner_isActive_false: {
        backgroundColor: Colors.transparent,
    },
    imageWithTextContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    label: {
        fontSize: Fonts.size.h6,
        fontFamily: Fonts.type.VFFont,
    },
})

export default styles
